export default __webpack_public_path__ + "static/media/placeholder-3.5b9ad56b.jpg";